<template>
<div>
	<div class="container">
		<div class="page">
			<div class="d-flex justify-content-center">
				<img :src="banner" class="mb-4 banner" />
			</div>

			<div class="container-fluid">
				<div class="row d-flex justify-content-center">
					<div class="col-lg-10 box">
						<div class="text-center p-2 h5 font-weight-bold">{{ $t('Mulai Dari Sini') }}</div>

						<form @submit.prevent="submitProductRequest" novalidate>
							<div class="row">

								<div class="col-md-12" v-if="isAdmin">
									<div class="form-group">
										<label>{{ $t('Pilih Seller') }} <span class="text-danger">*</span>
											<div class="spinner-grow spinner-grow-sm ml-2" role="status" v-if="isSearchingSeller">
												<span class="sr-only">Loading...</span>
											</div>
										</label>
										<multiselect v-model="selectedSeller" class="orders-status-list multiselect-auto-width form-control"
											placeholder="Select Seller (Name - Email)" track-by="email" label="label"
											:options="sellerOptions" :show-labels="false" :allow-empty="false" :multiple="false"
											:class="{ 'multiselect-invalid': errorMessages.selectedSeller }" @select="onSellerChange" @search-change="fetchDataSeller">
											<span slot="noResult">{{ $t('No Seller found') }}</span>
											<span slot="noOptions">
												Type seller name or email ...
											</span>
										</multiselect>
										<small v-if="errorMessages.selectedSeller" class="text-danger">
											{{ errorMessages.selectedSeller }}
										</small>
									</div>
								</div>

								<div class="col-md-6">
									<div class="form-group">
										<label>{{ $t('Jenis Produk Yang Diminati') }} <span class="text-danger">*</span></label>
										<div class="mb-2">
											<multiselect placeholder="Select Category" label="name" track-by="slug"
												@close="categoryValidation" @select="onCategoryChange"
												v-model="selectedCategory" :options="categories" :show-labels="false"
												:allow-empty="false" :disabled="categories.length === 0">
											</multiselect>
											<small v-if="errorMessages.category" class="text-danger">
												{{ errorMessages.category }}
											</small>
										</div>

										<div>
											<multiselect v-if="subCategories" placeholder="Select Sub Category"
												label="name" track-by="slug" v-model="selectedSubCategory"
												:options="subCategories" :show-labels="false" :allow-empty="false"
												:disabled="subCategories.length === 0">
											</multiselect>
											<small v-if="errorMessages.subCategory" class="text-danger">
												{{ errorMessages.subCategory }}
											</small>
										</div>
									</div>

									<div class="form-group">
										<label>{{ $t('Harga Rekomendasi') }} <span class="text-danger">*</span></label>
										<div class="input-group">
											<div class="input-group-prepend">
												<div class="input-group-text">
													{{ currencySymbol }}
												</div>
											</div>
											<input type="text" class="input form-control" min="0"
												:class="{ 'is-invalid': errorMessages.price }" @input="onPriceChange"
												@change="onPriceChanges" v-model="price" />
											<small v-if="errorMessages.price" class="invalid-feedback">
												{{ errorMessages.price }}
											</small>
										</div>
									</div>
								</div>

								<div class="col-md-6">
									<div class="form-group textarea-container">
										<label>{{ $t('Deskripsi Produk') }} ({{ $t('Spesifikasi Produk') }}) <span
												class="text-danger">*</span></label>
										<textarea class="form-control textarea-style"
											:class="{ 'is-invalid': errorMessages.description }"
											placeholder="Masukkan Deskripsi Produk..." required
											v-model="description"></textarea>
										<small v-if="errorMessages.description" class="invalid-feedback">
											{{ errorMessages.description }}
										</small>
									</div>
								</div>

								<div class="row mx-0 w-100">
									<div class="col-md-4">
										<label>{{ $t('Contoh Foto Produk') }}</label>
										<p class="pc-p">
											Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300px (Untuk gambar
											optimal gunakan ukuran minimum 700 x 700 px). Ukuran maksimum gambar adalah
											<b>2MB</b>.
										</p>
										<small v-if="errorMessages.image" class="text-danger">
											{{ errorMessages.image }}
										</small>
									</div>
									<div class="col-md-8">
										<div class="box__content">
											<div class="pc-images-list">
												<draggable draggable=".draggable" v-model="product.images"
													v-bind="dragOptions" @start="drag = true" @end="drag = false">
													<transition-group class="row small-gutter" type="transition"
														:name="!drag ? 'flip-list' : null">
														<div class="col" :class="{ draggable: image !== '' }"
															v-for="(image, index) in product.images" :key="index + 0">
															<div v-if="isLoading && image === ''"
																class="pc-image-empty">
																<div class="image-loading">
																	<div class="is-loading"></div>
																</div>
															</div>
															<div v-else-if="image === ''"
																class="pc-image-empty cursor-pointer"
																@click="uploadImages(index)">
																<div class="image-upload-placeholder">
																	<i class="fi fi-rr-picture image-placeholder"></i>
																	<div class="text-placeholder">
																		Foto {{ index + 1 }}
																	</div>
																</div>
															</div>
															<div v-else class="pc-image" :class="{
																'is-loading': image === '',
															}">
																<div class="img"
																	:style="{ backgroundImage: `url('${image}')` }">
																</div>
																<i class="material-icons" v-tooltip="'Remove'"
																	@click="removeProductImages(index)">close</i>
															</div>
														</div>
													</transition-group>
												</draggable>
											</div>
											<div class="form-group buttons m-0 hidden">
												<input type="file" accept="image/*" class="input-file"
													ref="imageUploader" id="pc-product-images-file"
													@change="onProductImagesChange" />
											</div>
										</div>
									</div>
								</div>

								<div class="col-md-12">
									<div class="form-group">
										<label>{{ $t('Link Referensi Produk') }}</label>
										<input type="text" class="form-control" placeholder="https://"
											v-model.trim="referenceLink">
										<small v-if="errorMessages.referenceLink" class="text-danger">{{
											errorMessages.referenceLink }}</small>
									</div>
								</div>

								<div class="col-md-12">
									<div class="form-group">
										<label>{{ $t('Berapa rata-rata jumlah penjualan Anda?') }} <span
												class="text-danger">*</span></label>
										<div class="input-group">
											<div class="input-group-prepend">
												<button
													class="btn btn-outline-secondary dropdown-toggle"
													:class="{
														'border-error': errorMessages.selectedSalesPeriod,
														'border-normal': !errorMessages.selectedSalesPeriod,
													}"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													{{ selectedSalesPeriodLabel }}
												</button>
												<div class="dropdown-menu">
													<a
														class="dropdown-item"
														@click="assignPeriod(period.value)"
														v-for="(period, idx) in salesPeriodOptions"
														:key="idx"
													>
														{{ period.label }}
													</a>
												</div>
											</div>
											<input
												type="text"
												class="input form-control"
												min="0"
												:class="{ 'is-invalid': errorMessages.salesValue }"
												@input="onSalesValueChange"
												@change="onSalesValueChanges"
												v-model="salesValue"
											/>
										</div>
										<div class="row">
											<small v-if="errorMessages.selectedSalesPeriod" class="col-md-12 text-danger">{{
												errorMessages.selectedSalesPeriod }}</small>
											<small v-if="errorMessages.salesValue" class="col-md-12 text-danger">{{
												errorMessages.salesValue }}</small>
										</div>
									</div>
								</div>

								<div class="col-md-12 d-flex justify-content-center">
									<div class="form-group">
										<recaptcha v-if="isGoogleRecaptchaEnabled" ref="recaptcha"></recaptcha>
									</div>
								</div>

								<div class="col-md-12">
									<div class="form-group">
										<button type="submit" class="btn btn-primary btn-block" :class="{
											'is-loading': isSubmit,
										}">Submit</button>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>

		</div>
	</div>

	<main-footer v-if="!isAdmin" />
</div>
</template>

<script>
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
import { duplicateVar, isUrlValid, getAxiosErrorMessage } from '@/lib/helper';
import homepageApi from '@/api/homepage';
import mediaApi from '@/api/media';
import { createProductRequest } from '@/api/product-request';
import adminApi from '@/api/admin';
import MainFooter from '@/components/homepages/Footer.vue';
import Recaptcha from '@/components/Recaptcha.vue';
import { salesRangeOptions, salesPeriodOptions } from '@/lib/statics';

export default {
	name: 'ProductRequest',
	components: {
		MainFooter,
		Recaptcha,
		draggable,
	},
	data() {
		return {
			banner: 'https://cdn.ostock.id/img/banners/request-product.png',
			isFetchingCategories: false,
			categories: [],
			subCategories: [],
			selectedCategory: null,
			selectedSubCategory: null,
			description: '',
			price: 0,
			isLoading: false, // is uploading images
			drag: false,
			dragOptions: {
				animation: 100,
			},
			product: {
				images: ['', '', '', '', ''],
			},
			productImages: [],
			productImagesLimit: 5,
			referenceLink: '',
			salesRangeOptions,
			salesPeriodOptions,
			selectedSalesPeriod: '',
			selectedSales: '',
			salesValue: 0,
			submitError: null,
			selectedSeller: null,
			sellerOptions: [],
			isSubmit: false,
			isSearchingSeller: false,
			errorMessages: {
				category: '',
				subCategory: '',
				description: '',
				price: '',
				image: '',
				referenceLink: '',
				selectedSales: '',
				salesValue: '',
				selectedSalesPeriod: '',
				selectedSeller: '',
			},
		};
	},
	methods: {
		fetchDataSeller(query) {
			if (query !== '') {
				this.isSearchingSeller = true;
			}

			const params = {
				keyword: query,
				role: 'owner',
				owner_type: 'dropshipper',
			};

			const callback = (response) => {
				this.sellerOptions = response.data;
				this.isSearchingSeller = false;
			};

			const errorCallback = (e) => {
				this.isSearchingSeller = false;
				const msg = getAxiosErrorMessage(e);

				this.$notify({
					group: 'app',
					title: 'Fetch Sellers',
					text: msg,
					type: 'error',
				});
			};

			this.ooDelay(() => {
				if (query !== '') {
					adminApi.searchUser(params, callback, errorCallback);
				}
			}, 1000);
		},
		onSellerChange(seller) {
			this.selectedSeller = seller;
		},
		categoryValidation() {
			if (this.selectedCategory
				&& this.selectedCategory.slug !== 'uncategorized'
				&& this.selectedCategory.slug !== 'produk-lainnya') {
				this.errorMessages.category = '';
			} else {
				this.errorMessages.category = 'Kategori Wajib Dipilih';
			}
		},
		subCategoryValidation() {
			if (this.selectedSubCategory) {
				this.errorMessages.subCategory = '';
			} else {
				this.errorMessages.subCategory = 'Sub Kategori Wajib Dipilih';
			}
		},
		descriptionValidation() {
			if (this.description.length <= 0) {
				this.errorMessages.description = 'Deskripsi Wajib Diisi';
			} else {
				this.errorMessages.description = '';
			}
		},
		priceValidation() {
			if (parseInt(this.price) === 0 || this.price.length <= 0) {
				this.errorMessages.price = 'Harga Wajib Diisi';
			} else {
				this.errorMessages.price = '';
			}
		},
		linkImageValidation() {
			const image = this.product.images.find(img => img !== '');
			if (!image && !this.referenceLink) {
				this.errorMessages.image = 'Upload minimal 1 gambar atau isi Link Referensi';
				this.errorMessages.referenceLink = 'Isi Link Referensi atau Upload minimal 1 gambar';
			} else if (this.referenceLink && !isUrlValid(this.referenceLink)) {
				this.errorMessages.referenceLink = 'Link harus valid dan diawali https:// atau http://';
			} else {
				this.errorMessages.image = '';
				this.errorMessages.referenceLink = '';
			}
		},
		salesValidation() {
			if (this.selectedSales === '') {
				this.errorMessages.selectedSales = 'Total Penjualan Per Hari Wajib Dipilih';
			} else {
				this.errorMessages.selectedSales = '';
			}
		},
		salesValueValidation() {
			if (parseInt(this.salesValue) === 0 || this.salesValue.length <= 0) {
				this.errorMessages.salesValue = 'Rata-rata Jumlah Penjualan Wajib Diisi';
			} else {
				this.errorMessages.salesValue = '';
			}
		},
		salesPeriodValidation() {
			this.errorMessages.selectedSalesPeriod = '';

			if (this.selectedSalesPeriod === '') {
				this.errorMessages.selectedSalesPeriod = 'Periode Wajib Dipilih';
			}
		},
		sellerValidation() {
			this.errorMessages.selectedSeller = '';

			if (!this.selectedSeller && this.isAdmin) {
				this.errorMessages.selectedSeller = 'Seller Wajib Dipilih';
			}
		},
		validateAllForm() {
			this.categoryValidation();
			// this.subCategoryValidation();
			this.descriptionValidation();
			this.priceValidation();
			this.linkImageValidation();
			// this.salesValidation();
			this.salesValueValidation();
			this.salesPeriodValidation();
			this.sellerValidation();
		},
		// form validation end
		fetchCategories() {
			this.isFetchingCategories = true;
			const callback = (response) => {
				this.isFetchingCategories = false;
				const categories = response.data;
				this.categories = categories;
			};
			const errorCallback = () => {
				this.isFetchingCategories = false;
			};
			homepageApi.getAllCategories(callback, errorCallback);
		},
		onCategoryChange(category) {
			this.selectedSubCategory = null;
			this.subCategories = category?.sub_categories;
		},
		parsePricing(price) {
			let parsedPrice = price.replace(/[^0-9]/g, '').trim();
			const parsedPriceLength = parsedPrice.length;
			if (parsedPriceLength > 1 && parsedPrice.charAt(0) === '0') {
				parsedPrice = parsedPrice.substring(1, parsedPriceLength);
			}
			return parsedPrice;
		},
		onPriceChange() {
			this.price = this.parsePricing(this.price);
		},
		onPriceChanges() {
			if (this.price === '') {
				this.price = 0;
			}
		},
		onSalesValueChange() {
			this.salesValue = this.parsePricing(this.salesValue);
		},
		onSalesValueChanges() {
			if (this.salesValue === '') {
				this.salesValue = 0;
			}
		},
		uploadImages(index) {
			this.currentIndexUploadImage = index;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onProductImagesChange(event) {
			this.isLoading = true;
			const maxUploadSize = 2; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				// Limit Images
				const isLimitReached =
					this.productImages.length === this.productImagesLimit;
				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 2MB)`;
					this.$notify({
						group: 'app',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading = false;
					break;
				}

				if (isLimitReached) {
					const noticeMessage = 'Maksimum upload 5 foto produk';
					this.$notify({
						group: 'app',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading = false;
					break;
				}

				this.productImages.push(image);

				const previewIndex = this.currentIndexUploadImage;

				this.$set(this.product.images, previewIndex, '');

				// Load the image file into a canvas element
				const img = new Image();
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				const reader = new FileReader();
				// eslint-disable-next-line no-loop-func
				reader.onload = () => {
					img.onload = () => {
						const size = Math.max(img.width, img.height);
						canvas.width = size;
						canvas.height = size;
						const offsetX = (size - img.width) / 2;
						const offsetY = (size - img.height) / 2;
						ctx.fillStyle = '#fff';
						ctx.fillRect(0, 0, size, size); // fill the canvas with white
						ctx.drawImage(img, offsetX, offsetY);

						// Convert the canvas to a blob and upload it to the server
						canvas.toBlob((blob) => {
							// Start Upload
							const uploadParams = new FormData();
							uploadParams.append('image', blob);

							const callback = (response) => {
								this.isLoading = false;
								const path = response.data;
								const url = `${this.mediaUrlPrefix}/${path}`;
								this.$set(this.product.images, previewIndex, url);
								this.linkImageValidation();
							};

							const errorCallback = () => {
								this.isLoading = false;
								// eslint-disable-next-line
								this.productImages.splice(previewIndex, 1);
								this.product.images.splice(previewIndex, 1);
								this.linkImageValidation();
							};

							// Upload Image
							mediaApi.uploadImagePublic(uploadParams, callback, errorCallback);
						}, image.type, 0.9);
					};
					img.src = reader.result;
				};
				reader.readAsDataURL(image);
			}
			event.target.files = null;
			event.target.value = '';
		},
		removeProductImages(index) {
			this.productImages.splice(index, 1);
			this.product.images.splice(index, 1, '');
		},
		getCategoryParams() {
			const selectedSubCategory = duplicateVar(this.selectedSubCategory);
			const selectedCategory = duplicateVar(this.selectedCategory);
			delete selectedSubCategory.sub_sub_categories;
			delete selectedCategory.sub_categories;
			delete selectedCategory._id;
			delete selectedSubCategory._id;
			delete selectedSubCategory.parent_id;

			const category = {
				...selectedCategory,
				sub_category: selectedSubCategory,
			};

			return category;
		},
		storeProductRequest() {
			this.isSubmit = true;

			const category = this.getCategoryParams();

			const params = {
				category,
				description: this.description,
				price: parseInt(this.price),
				product_images: this.product.images,
				reference_link: this.referenceLink,
				sales: this.salesValue,
				sales_period: this.selectedSalesPeriod,
			};

			if (this.selectedSeller) {
				params.seller_id = this.selectedSeller?._id;
			}

			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					title: 'Save Product Request',
					text: message,
					type: 'success',
				});
				this.isSubmit = false;

				if (this.isAdmin) {
					this.$router.push('/admin/request-product');
				} else {
					this.$router.push('/request-product/list');
				}
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Save Product Request',
					text: message,
					type: 'error',
				});
				this.isSubmit = false;
			};

			createProductRequest(params, callback, errorCallback);
		},
		submitProductRequest() {
			this.validateAllForm();
			const isErrorExist = Object.values(this.errorMessages).find(val => val !== '');
			if (isErrorExist) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Form harus diisi.',
				});
				return;
			}

			const gRecaptchaResponse = document.getElementsByName('g-recaptcha-response')[0]?.value ?? '';

			if (this.isGoogleRecaptchaEnabled && gRecaptchaResponse === '') {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Recaptcha harus diisi.',
				});
			} else {
				this.storeProductRequest();
			}
		},
		checkUser() {
			if (this.isSupplier) {
				this.$router.push('/403');
			}
		},
		assignPeriod(value) {
			this.selectedSalesPeriod = value;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			currency: 'currency',
			isDropshipper: 'isDropshipper',
			isAdmin: 'isAdmin',
			isSupplier: 'isSupplier',
			isGoogleRecaptchaEnabled: 'isGoogleRecaptchaEnabled',
		}),
		currencySymbol() {
			return this.getCurrencySymbol(this.currency);
		},
		selectedSalesPeriodLabel() {
			let label = 'Periode';
			const period = this.salesPeriodOptions.find(period => period.value === this.selectedSalesPeriod);

			if (period && period.label) {
				label = period.label;
			}

			return label;
		},
	},
	watch: {
		description() {
			this.descriptionValidation();
		},
		price() {
			this.priceValidation();
		},
		salesValue() {
			this.salesValueValidation();
		},
		selectedSalesPeriod() {
			this.salesPeriodValidation();
		},
		referenceLink() {
			this.linkImageValidation();
		},
		submitError() {
			if (typeof window.grecaptcha !== 'undefined') {
				window.grecaptcha.reset();
			}
		},
	},
	created() {
		this.checkUser();
		this.fetchCategories();
	},
};
</script>

<style lang="scss" scoped>
.textarea-container {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding-bottom: 16px;
}

.textarea-style {
	flex: 1;
	resize: none;
}

.banner {
	border-radius: 16px;
	width: 1296px;
}

.border-normal {
	border: 1px solid #ced4da;
}

.border-error {
	border: 1px solid red;
}

.multiselect-invalid {
	.multiselect__tags {
		border-color: #ed1c24;
	}
}
</style>
